import { graphql } from "gql.tada";

export const SUPPORT_INQUIRY_MUTATION = graphql(`
  mutation SupportInquiry($input: SupportInquiry!) {
    supportInquiry(input: $input)
  }
`);
